import { ApiService } from '../shared/services/api-service/api.service';
import { IGuestProfile } from './interfaces/loyalty.interfaces';

class LoyaltyServiceClass {
    private static _instance: LoyaltyServiceClass;
    public static get instance() {
        return this._instance || (this._instance = new this());
    }
    private constructor() { }

    /**
     * Method to get loyalty profile
     * @param chainCode
     * @param memberToken
     * @param memberId
     */
    async getProfile(chainCode: string, memberToken: string, memberId: string = '123'): Promise<IGuestProfile> {
        try {
            const loyaltyGuestProfileResponse = await ApiService.getLoyaltyGuestProfile(chainCode, memberToken, memberId);
            const loyaltyGuestProfile: IGuestProfile = await loyaltyGuestProfileResponse.json();
            return loyaltyGuestProfile;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const LoyaltyService = LoyaltyServiceClass.instance;
